import { render, staticRenderFns } from "./form_upload.vue?vue&type=template&id=fa12e0d4&scoped=true&"
import script from "./form_upload.vue?vue&type=script&lang=js&"
export * from "./form_upload.vue?vue&type=script&lang=js&"
import style0 from "./form_upload.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./form_upload.vue?vue&type=style&index=1&id=fa12e0d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa12e0d4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VForm,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa12e0d4')) {
      api.createRecord('fa12e0d4', component.options)
    } else {
      api.reload('fa12e0d4', component.options)
    }
    module.hot.accept("./form_upload.vue?vue&type=template&id=fa12e0d4&scoped=true&", function () {
      api.rerender('fa12e0d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/form_upload.vue"
export default component.exports